import { render, staticRenderFns } from "./add-agency-screen.vue?vue&type=template&id=53d4e832&scoped=true"
import script from "./add-agency-screen.vue?vue&type=script&lang=js"
export * from "./add-agency-screen.vue?vue&type=script&lang=js"
import style0 from "./add-agency-screen.vue?vue&type=style&index=0&id=53d4e832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4e832",
  null
  
)

export default component.exports